var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usecases"},[_c('UsecasesDashboard',{attrs:{"id":"use-cases-pg"}}),_c('UsescasesIdentityVerification'),_c('UsecasesIdentityFraudDetection'),_c('UsecasesUserOnboarding'),_c('UsecasesAgeVerification'),_c('GetStarted')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }